import { Routes } from '@angular/router';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { loggedGuard } from './auth/logged.guard';
import { LoginComponent } from './components/login/login.component';
import { unloggedGuard } from './auth/unlogged.guard';
//import { ManageAudiosComponent } from './components/manage-audios/manage-audios.component';
import { ManagePhotosComponent } from './components/manage-photos/manage-photos.component';
import { ManageVideosComponent } from './components/manage-videos/manage-videos.component';
import { adminGuard } from './auth/admin.guard';
import { ManageAudiosComponent } from './components/manage-audios/manage-audios.component';
import { ManageAlbumsComponent } from './components/manage-album/manage-albums.component';

export const routes: Routes = [

    {path: '', component: LandingPageComponent, canActivate: [loggedGuard]},

    {path: 'login', component: LoginComponent, canActivate: [unloggedGuard]},

    // ADMIN
    //{path: 'backup', component: BackupComponent, canActivate: [adminGuard]},
    {path: 'manage-audios', component: ManageAudiosComponent, canActivate: [adminGuard]},
    {path: 'manage-videos', component: ManageVideosComponent, canActivate: [adminGuard]},
    {path: 'manage-photos', component: ManagePhotosComponent, canActivate: [adminGuard]},
    {path: 'manage-albums', component: ManageAlbumsComponent, canActivate: [adminGuard]},

    // SUPER
    //{path: 'manage-users', component: ManageUsersComponent, canActivate: [superGuard]},
    //{path: 'test', component: TestComponent, canActivate: [superGuard]}


];
